export enum UserJourneyDataKey {
  /** Unique identifier for the page */
  PAGE_ID = 'page_id',

  /** Unique identifier for the storefront */
  STOREFRONT_ID = 'storefront_id',

  /** Display name of the storefront */
  STOREFRONT_NAME = 'storefront_name',

  /** Unique identifier for the tab */
  TAB_ID = 'tab_id',

  /** Display name of the tab */
  TAB_NAME = 'tab_name',

  /** Unique identifier for the container (e.g., module, rail, section) */
  CONTAINER_ID = 'container_id',

  /** Display name of the container */
  CONTAINER_NAME = 'container_name',

  /** Unique identifier for the collection (e.g., curated group of content) */
  COLLECTION_ID = 'collection_id',

  /** Display name of the collection */
  COLLECTION_NAME = 'collection_name',

  /** The current screen/page the user is viewing */
  CURRENT_SCREEN = 'current_screen',

  /** Position of the item in the search results */
  SEARCH_ITEM_POSITION = 'search_item_position',

  /** Position of the container within the page layout */
  CONTAINER_POSITION = 'container_position',

  /** Position of the item (card) within a carousel or container */
  CARD_POSITION = 'card_position',
}
